(ns practitest.frontend.project-general-settings.subs
  (:require
    [re-frame.core :as re-frame]
    [practitest.frontend.project-general-settings.events :refer [db-key]]))

(re-frame/reg-sub ::state (fn [db _] (get db db-key)))
(re-frame/reg-sub ::data :<- [::state] (fn [s _] (:data s)))
(re-frame/reg-sub ::form :<- [::state] (fn [s _] (:form s)))
(re-frame/reg-sub ::errors :<- [::state] (fn [s _] (:errors s)))
(re-frame/reg-sub ::saving? :<- [::state] (fn [s _] (boolean (:saving? s))))
(re-frame/reg-sub ::remove-logo-confirm? :<- [::state] (fn [s _] (boolean (:remove-logo-confirm? s))))
(re-frame/reg-sub ::annotation-modal :<- [::state] (fn [s _] (:annotation-modal s)))
